<template>
  <div>
    <div class="container mt-1">
      <div class="card form-card">
        <div class="card-body text-center">
          <form @submit.prevent="verifyTpin">
            <img class="m-2" height="100px" src="@/assets/img/screenshot.png">

            <h5 class="card-title mb-2">Smart Invoice Registration Form</h5>
            <h5 class="card-title mb-4">Tpin Verification</h5>

            <div v-if="loading" class="loader">Verifying...</div> <!-- Loader during verification -->

            <div v-else class="form-group mb-1">
              <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Enter Tpin Number"
                  v-model="Tpin"
                  required
              />
            </div>

            <button class="btn btn-primary" :disabled="loading">Verify</button> <!-- Disable button during loading -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";

export default {
  beforeMount() {
    localStorage.removeItem(`tpinResponse`)
  },
  data() {
    return {
      Tpin: '', // Define the Tpin data property
      loading: false, // State for managing the loader
    };
  },
  methods: {
    async verifyTpin() {
      this.loading = true; // Start loader
      try {
        // Construct the URL with the Tpin as a query parameter
        const url = `${directorStatus}director-info?TPIN=${encodeURIComponent(this.Tpin)}`;

        // Perform the GET request with the Tpin included in the URL
        const { data } = await axios.get(url);

        // Check if the response contains a 'response' field
        if (data.response) {
          // Save the response in local storage or Vuex store for use on the next page
          localStorage.setItem('tpinResponse', JSON.stringify(data.response));
        }

        // Navigate to the next page (Signup)
        this.$router.push({ name: 'Signup' });
      } catch (error) {
        // Handle errors using the errorHandler service
        errorHandler(error);
        console.error("Error verifying Tpin:", error);
      } finally {
        this.loading = false; // Stop loader
      }
    },
  },
};
</script>
<style scoped>
html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
}
.loader {
  font-size: 16px;
  font-weight: bold;
}
.form-card {
  max-width: 500px;
  width: 100%;
  margin: 30px auto 0; /* Center the card horizontally and add top margin */
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-body {
  padding: 30px;
}

.card-title {
  font-weight: bold;
}

@media (max-width: 768px) {
  .card-body {
    padding: 20px;
  }
}

@media (max-width: 576px) {
  .card-body {
    padding: 15px;
  }

  .form-group {
    margin-bottom: 10px;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
  }

  .btn-group .btn {
    margin: 0 5px;
  }
  .btn {
    font-size: 14px;
  }
}
</style>
